<template>
  <svg
    :width="width ? width : height ? height : 35"
    :height="height ? height : width ? width : 35"
    viewBox="0 0 35 35"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >

    <g
      fill-rule="nonzero"
      fill="none"
    >
      <path
        d="M17.4.55a17 17 0 1 0 0 34 17 17 0 0 0 0-34z"
        :fill="fillColor"
      />
      <path
        d="M21.78 26.58l-6.33-4.6a.87.87 0 0 1-.35-.7V9.22c0-.47.39-.86.86-.86h3.45c.47 0 .86.39.86.86v9.88l4.55 3.32c.39.28.47.81.19 1.2l-2.02 2.79a.87.87 0 0 1-1.21.18z"
        :stroke="fillColor"
        stroke-width="2"
        :fill="strokeColor"
      />
    </g>

  </svg>
</template>

<script>
export default {
  name: 'urskive',
  props: {
    fillColor: {
      type: String,
      default: '#ffffff',
    },
    strokeColor: {
      type: String,
      default: '#0F1C70',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
